document.addEventListener('DOMContentLoaded', function () {
  const carousel = document.getElementById('galleryCarousel');
  if (!carousel) return;
  
  const track = carousel.querySelector('.mente-product-gallery__track');
  const slides = carousel.querySelectorAll('.mente-product-gallery__slide');
  const dots = document.querySelectorAll('.mente-product-gallery__dot');
  const modal = document.getElementById('galleryModal');
  const modalImage = document.getElementById('galleryModalImage');
  const modalClose = document.getElementById('galleryModalClose');

  let currentIndex = 0;
  let isDown = false;
  let startX;
  let scrollLeft;
  let hasDragged = false;

  // Detect if primarily touch device (mobile/tablet)
  const isTouchDevice = ('ontouchstart' in window || navigator.maxTouchPoints > 0) && 
                        !/Mobi|Android|iPad|iPhone/i.test(navigator.userAgent) === false;

  // Update active dot based on scroll position
  function updateActiveDot() {
    const scrollLeft = track.scrollLeft;
    const slideWidth = slides[0].offsetWidth;
    const newIndex = Math.round(scrollLeft / slideWidth);
    
    if (newIndex !== currentIndex) {
      currentIndex = newIndex;
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === currentIndex);
      });
    }
  }

  // Scroll to slide on dot click
  dots.forEach((dot) => {
    dot.addEventListener('click', function () {
      const index = parseInt(this.dataset.index);
      const slideWidth = slides[0].offsetWidth;
      track.scrollTo({
        left: slideWidth * index,
        behavior: 'smooth'
      });
    });
  });

  // Update dots on scroll
  track.addEventListener('scroll', updateActiveDot);

  // Prevent default image drag behavior
  slides.forEach((slide) => {
    const img = slide.querySelector('img');
    if (img) {
      img.addEventListener('dragstart', (e) => e.preventDefault());
      img.style.userSelect = 'none';
      img.style.pointerEvents = 'none';
    }
  });

  // Mouse drag to scroll
  track.addEventListener('mousedown', (e) => {
    e.preventDefault(); // Prevent default drag behavior
    isDown = true;
    hasDragged = false;
    track.style.cursor = 'grabbing';
    track.style.scrollSnapType = 'none'; // Disable snap while dragging
    track.style.scrollBehavior = 'auto'; // Disable smooth scroll while dragging
    startX = e.pageX;
    scrollLeft = track.scrollLeft;
  });

  track.addEventListener('mouseleave', () => {
    if (isDown) {
      isDown = false;
      track.style.cursor = 'grab';
      snapToNearestSlide();
    }
  });

  track.addEventListener('mouseup', () => {
    if (isDown) {
      isDown = false;
      track.style.cursor = 'grab';
      snapToNearestSlide();
    }
  });

  track.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX;
    const walk = x - startX; // 1:1 movement with mouse
    track.scrollLeft = scrollLeft - walk;
    if (Math.abs(walk) > 5) hasDragged = true;
  });

  // Snap to nearest slide
  function snapToNearestSlide() {
    track.style.scrollSnapType = 'x mandatory';
    track.style.scrollBehavior = 'smooth';
    const slideWidth = slides[0].offsetWidth;
    const newIndex = Math.round(track.scrollLeft / slideWidth);
    track.scrollTo({
      left: slideWidth * newIndex,
      behavior: 'smooth'
    });
  }

  // Also listen for mouseup on document to catch releases outside track
  document.addEventListener('mouseup', () => {
    if (isDown) {
      isDown = false;
      track.style.cursor = 'grab';
      snapToNearestSlide();
    }
  });

  // Click slide to open modal (only on touch devices)
  if (isTouchDevice) {
    slides.forEach((slide) => {
      slide.addEventListener('click', function () {
        const img = this.querySelector('img');
        modalImage.src = img.src;
        modalImage.alt = img.alt;
        modal.classList.add('active');
      });
    });

    // Close modal
    modalClose.addEventListener('click', function () {
      modal.classList.remove('active');
    });

    // Close modal on background click
    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        modal.classList.remove('active');
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        modal.classList.remove('active');
      }
    });
  }
});
